import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { MyNotifications } from '@app/core/models';
import { ApiService } from '@app/core/services/api.service';
/**
 * MyNotificationsService
 */
@Injectable({ providedIn: 'root' })
export class MyNotificationsService {
  get notifiedFlag(): boolean {
    return this._notifiedFlag;
  }

  set notifiedFlag(value: boolean) {
    this._notifiedFlag = value;
  }
  private _notifiedFlag = false;
  /**
   * url
   */
  public url;

  /**
   * constructor
   * @param apiService
   * @param redux
   */
  constructor(private apiService: ApiService) { }

  /**
   * getMyNotifications
   * @returns {Observable<MyNotiifcation[]>}
   */
  getMyNotifications(programKey: string): Observable<MyNotifications[]> {
    const options = {
      headers: {
        programKey
      },
    };
    return this.apiService.get('/notification', options);
  }
}
